import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
import i18n from '@/i18n'
/* Router Modules */
Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar
 noCache: true                if set true, the page will no be cached(default is false)
 affix: true                  if set true, the tag will affix in the tags-view
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
]

export const adminRoutes = [
  {
    path: '/',
    component: () => import('@/views/login'),
  },
  {
    path: '/source',
    component: Layout,
    redirect: '/source/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/source/index'),
        name: 'source',
        meta: {
          id: "SOURCE",
          title: i18n.t('message.source.module'), icon: 'list', affix: true
        }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/account/index'),
        name: 'accountInfo',
        meta: {
          id: "ACCOUNT_INFO",
          title: i18n.t('message.accountInfo.module'), icon: 'customer', affix: true
        }
      }
    ]
  },
  {
    path: '/ledger',
    component: Layout,
    redirect: '/ledger/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/ledger/index'),
        name: 'ledger',
        meta: {
          id: "LEDGER",
          title: i18n.t('message.ledger.module'), icon: 'chart', affix: true
        }
      }
    ]
  },

  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/admin-list',
    name: i18n.t('message.sys.module'),
    meta: {
      id: "SYS",
      title: i18n.t('message.sys.module'),
      icon: 'setting',
    },
    children: [
      {
        path: 'admin-list',
        component: () => import('@/views/sys/admin-list'),
        name: 'AdminList',
        meta: {
          title: i18n.t('message.sys.admin.module'), noCache: true
        }
      },
    ]
  }
]
export const notFound = [
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true}
]
const buildRouter = () => {
  return constantRoutes.concat(adminRoutes).concat(notFound)
}
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  mode: "history",
  routes: buildRouter()
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/admin/router/index.js